import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2019. Plesk International GmbH. All rights reserved.
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CLS_PREFIX } from '../../constants';

var ProgressBar = function ProgressBar(_ref) {
  var _classNames;

  var baseClassName = _ref.baseClassName,
      className = _ref.className,
      intent = _ref.intent,
      progress = _ref.progress,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "intent", "progress"]);

  return React.createElement("div", _extends({
    className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--").concat(intent), intent), _defineProperty(_classNames, "".concat(baseClassName, "--indeterminate"), progress === -1), _classNames), className),
    style: progress >= 0 && progress <= 100 ? {
      width: "".concat(progress, "%")
    } : undefined
  }, props));
};

ProgressBar.propTypes = {
  /**
   * Visual intent color to apply to component.
   */
  intent: PropTypes.oneOf(['info', 'success', 'danger']),

  /**
   * Progress indication in numbers
   */
  progress: PropTypes.number,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
ProgressBar.defaultProps = {
  intent: null,
  progress: -1,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "progress-step-progress-bar")
};
export default ProgressBar;